 import DestinationDisplay from "./DestinationDisplay";


interface Props {
  destination: {
    name: string,
    descMeta: string,
    uri: string,
  };
  id: number;
}

const Destination = ({destination, id }: Props) => {
  if (!destination) return null;
  return (
    <DestinationDisplay name={destination.name} descMeta={destination.descMeta} uri={destination.uri} id={id} />
  );
};

export default Destination;
 